import AdminVehicleList from '@/components/Vehicle/AdminVehicleList'
import AdminVehicleForm from '@/components/Vehicle/AdminVehicleForm'
import AdminVehicleDetail from '@/components/Vehicle/AdminVehicleDetail'

let VehicleRouter = [
    {
        path: '/admin/vehicle',
        name: 'AdminVehicleList',
        component: AdminVehicleList,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/admin/vehicle/new',
        name: 'AdminVehicleNew',
        component: AdminVehicleForm,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/admin/vehicle/:id/edit',
        name: 'AdminVehicleEdit',
        component: AdminVehicleForm,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/admin/vehicle/:id',
        name: 'AdminVehicleDetail',
        component: AdminVehicleDetail,
        meta: {
            requiresAuth: true
        }
    }
]

export default VehicleRouter



// WEBPACK FOOTER //
// ./src/components/Vehicle/router.js